export default "Piscines municipales — Collectivités | Solution Éco France";
